import React from "react";
import Box from "./Box";
import './styles.css';
function App() {
  return (
   <Box/>
  );
}

export default App;
